const { findByAddress } = require('@hints/utils/data');
const Interpretor = require('./interpretor');

module.exports = new Interpretor([
    {
        id: 'low-osa-risk',
        conditions: [{ id: 'score', min: 0, max: 2, value: e => findByAddress(e, 'evalSleep.stopbangAnswerScore') }],
    },
    {
        id: 'medium-osa-risk',
        conditions: [{ id: 'score', min: 3, max: 4, value: e => findByAddress(e, 'evalSleep.stopbangAnswerScore') }],
    },
    {
        id: 'high-osa-risk',
        conditions: [
            { id: 'male', callback: stopScoreWithBangFlagCondition('isMale') },
            { id: 'high-bmi', callback: stopScoreWithBangFlagCondition('hasHighBmi') },
            { id: 'large-neck', callback: stopScoreWithBangFlagCondition('hasLargeNeck') },
            { id: 'score', min: 5, max: 8, value: e => findByAddress(e, 'evalSleep.stopbangAnswerScore') }
        ],
    }
]);

function stopScoreWithBangFlagCondition(bangFlag) {
    return (evaluation) => {
        const stopScore = findByAddress(evaluation, 'evalSleep.stopAnswerScore');
        const flagValue = findByAddress(evaluation, `evalSleep.stopbangResult.${bangFlag}`);
        console.log('stopScore', stopScore);
        console.log('flagValue', bangFlag, flagValue);
        return stopScore >= 2 && flagValue === true;
    };
}